/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import './AddInsuranceModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import _ from 'lodash';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';

import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import { toast } from 'react-hot-toast';
import Compdirection from '../../../themes/CompDirection';
import { DatePickerInput } from '../../../../components';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allInsurerTypes: any;
  allPolicyTypes: any;
  callBackGetData: (data: any) => void;
  trans?: any;
}

const AddInsuranceModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allInsurerTypes,
  allPolicyTypes,
  trans,
}: ModalProps) => {
  const [amount, setAmount] = useState();
  const [policyNumber, setPolicyNumber] = useState();

  const [category, setCategory] = useState();

  const [policyTypeName, setPolicyTypeName] = useState('');
  const [policyTypeId, setPolicyTypeId] = useState('');

  const [insurerTypeName, setInsurerTypeName] = useState('');
  const [insurerTypeId, setInsurerTypeId] = useState(0);

  const [startDate, setStartDate] = useState<any>(new Date());
  const [endDate, setEndDate] = useState<any>(new Date());

  const [insuranceDocuments, setInsuranceDocuments] = useState();
  const [insuranceDocumentsPath, setInsuranceDocumentsPath] = useState('');
  const [newattachement, setNewAttachement] = useState(false);
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');
  const insuranceDocumentsUpload = (e: any) => {
    const _file: any = e.target.files[0];
    setNewAttachement(true);
    if (_file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);

      setInsuranceDocuments(_file);
      setInsuranceDocumentsPath(image_as_base64);
    } else {
      setInsuranceDocuments(_file);
      setIsPDF(true);
      setPDFName(_file?.name);
    }
  };

  const handleInsurerType = (insurerName: any) => {
    const getInsurer = _.filter(allInsurerTypes, function (insurer: any) {
      return insurer.name === insurerName;
    });
    if (getInsurer.length) {
      const insurer_type = getInsurer[0];
      setInsurerTypeId(insurer_type.id);
      setInsurerTypeName(insurerName);
    }
  };

  const handlePolicyType = (policyName: any) => {
    const getPolicy = _.filter(allPolicyTypes, function (policy: any) {
      return policy.name === policyName;
    });
    if (getPolicy.length) {
      const policy_type = getPolicy[0];
      setPolicyTypeId(policy_type.id);
      setPolicyTypeName(policyName);
    }
  };
  const handleSubmit = () => {
    callBackGetData({
      insurer: insurerTypeId,
      policy_type: policyTypeId,
      policy_number: policyNumber,
      start_date: startDate,
      end_date: endDate,
      category: category,
      amount: amount,
      attachments: insuranceDocuments,
      newattachement: newattachement,
    });
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="687px"
      modalWidth="550px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Add Insurance') }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={3}
          style={{
            marginTop: '15px',
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Insure')}
              options={_.map(allInsurerTypes, (insurer: any) => {
                return insurer.name;
              })}
              value={insurerTypeName}
              onChange={(event: any, newValue: any) => {
                handleInsurerType(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Policy Type')}
              options={_.map(allPolicyTypes, (policy: any) => {
                return policy.name;
              })}
              value={policyTypeName}
              onChange={(event: any, newValue: any) => {
                handlePolicyType(newValue);
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Policy Number')}
              placeholder={trans('Write Policy Number')}
              value={policyNumber}
              onChange={(e: any) => setPolicyNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Category')}
              placeholder={trans('Write Category')}
              value={category}
              onChange={(e: any) => setCategory(e.target.value)}
            />
          </Grid>

          <Grid item xs={6}>
            <DatePickerInput
              width="100%"
              label={trans('Start Date')}
              value={new Date(startDate)}
              onChange={(newValue: Date | string) => {
                if (newValue > endDate) {
                  toast.error(
                    trans('Start date should be less then end date.'),
                  );
                } else {
                  setStartDate(newValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePickerInput
              width="100%"
              label={trans('End Date')}
              value={new Date(endDate)}
              onChange={(newValue: Date | string) => {
                if (newValue < startDate) {
                  toast.error(
                    trans('End date should be greater then start date'),
                  );
                } else {
                  setEndDate(newValue);
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              type="number"
              label={trans('Amount')}
              placeholder={trans('Write Amount')}
              value={amount}
              onChange={(e: any) => setAmount(e.target.value)}
            />
          </Grid>

          <Grid item xs={5}>
            <DropAndSelect
              upload={insuranceDocumentsUpload}
              src={insuranceDocumentsPath}
              isPDF={isPDF}
              pdfName={pdfName}
              onDelete={() => {
                setIsPDF(false);
                setPDFName('');
                setInsuranceDocumentsPath('');
              }}
            />
          </Grid>
        </Grid>
      </Compdirection>

      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default AddInsuranceModalPresenter;
